import * as tslib_1 from "tslib";
import { OverlayService } from '../../core/overlay.service';
import { UserService } from '../../user.service';
import { DomainService } from '../../domain.service';
import { AlertsService } from '../../core/alerts.service';
var OpenProfileDirective = /** @class */ (function () {
    function OpenProfileDirective(overlayService, userService, domainService, alertsService) {
        this.overlayService = overlayService;
        this.userService = userService;
        this.domainService = domainService;
        this.alertsService = alertsService;
    }
    OpenProfileDirective.prototype.openProfile = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var resourceOid, entityType, resource;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!!this.key) return [3 /*break*/, 1];
                        // Opens user profile
                        this.overlayService.goToEntity(this.userService.user.Resource);
                        return [3 /*break*/, 3];
                    case 1:
                        resourceOid = DomainService.oidWith(90, this.key);
                        entityType = this.domainService.getEntityType('Resource');
                        return [4 /*yield*/, this.domainService.getEntityByKey(entityType, resourceOid).toPromise()];
                    case 2:
                        resource = _a.sent();
                        if (!this.overlayService.goToEntity(resource)) {
                            this.alertsService.createAlert('warning', 'APP.INPUTS.CAN_NOT_GO_TO_ENTITY');
                        }
                        _a.label = 3;
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    return OpenProfileDirective;
}());
export { OpenProfileDirective };
